export default "__VITE_ASSET__By7a9VxR__"